import React from "react";

const ServicesSectionn = () => {
  return (
    <section className="section services bggg">
      <div className="service-right">
        <img
          src="/img/bg/service-right.svg"
          className="img-fluid"
          alt="services right"
        />
      </div>

      <div className="container">
        {/* Heading title */}
        <div className="section-heading" data-aos="fade-down">
          <h2>How Omshree Cabs Works</h2>
          <p>
            Booking a ride with Omshree Cabs is simple and hassle-free. Just follow these easy steps:
          </p>
        </div>
        {/* /Heading title */}

        <div className="services-work">
          <div className="row">

            <div className="col-lg-4 col-md-4 col-12 d-flex" data-aos="fade-down">
              <div className="services-group service-date flex-fill">
                <div className="services-icon border-secondary">
                  <img
                    className="icon-img bg-secondary"
                    src="/img/icons/services-icon-01.svg"
                    alt="Choose Date & Location"
                  />
                </div>
                <div className="services-content">
                  <h3>1. Choose Date & Location</h3>
                  <p>
                    Select your pickup date, time, and location. Whether it’s the airport, railway station, or any city destination, we’ll get you there on time.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-4 col-12 d-flex" data-aos="fade-down">
              <div className="services-group service-loc flex-fill">
                <div className="services-icon border-warning">
                  <img
                    className="icon-img bg-warningg"
                    src="/img/icons/services-icon-02.svg"
                    alt="Select Your Ride"
                  />
                </div>
                <div className="services-content">
                  <h3>2. Select Your Ride</h3>
                  <p>
                    Choose the cab type that suits your needs — from economical cars to premium sedans or SUVs. Check availability and fare details before confirming.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-4 col-12 d-flex" data-aos="fade-down">
              <div className="services-group service-book flex-fill">
                <div className="services-icon border-dark">
                  <img
                    className="icon-img bg-dark"
                    src="/img/icons/services-icon-03.svg"
                    alt="Book Your Ride"
                  />
                </div>
                <div className="services-content">
                  <h3>3. Book Your Ride</h3>
                  <p>
                    Confirm your booking by providing your contact details. Receive instant confirmation along with your driver’s info. Sit back and enjoy a safe and comfortable ride with Omshree Cabs.
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSectionn;